import { DSARForm } from 'components/commercetools-ui/static-page-forms/DSARForm';
function DsarFormTastic() {
  return <DSARForm />;
}

export default DsarFormTastic;
